import api from '../api';

import { ParamsDataGenerateReschedulingFee, ParamsBodyGenerateReschedulingFee } from 'utils/typeServices';

export const PostGenerateReschedulingFee = async ({ token, body }: { token: string, body: ParamsBodyGenerateReschedulingFee }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: ParamsDataGenerateReschedulingFee }>('/v1/Pagamento/GenerateReschedulingFee', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
